export default __webpack_public_path__ + "static/media/cat_head.8741ca51.svg";